import { backendRequest } from "../utils/backend";

export const uploadProductsCsv = (vendorId, file) => {
    return backendRequest.post(`/pricelist/${vendorId}/import`, file, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
};